import * as z from 'zod';

import { departmentQuerySchema } from './department-query-schema';

export const departmentUpdateSchema = departmentQuerySchema
  .pick({ id: true, name: true, parent_id: true })
  .extend({ status: z.string() });
export type DepartmentUpdateSchema = z.infer<typeof departmentUpdateSchema>;

export const departmentCreateSchema = departmentUpdateSchema.omit({ id: true });
export type DepartmentCreateSchema = z.infer<typeof departmentCreateSchema>;
